import {Modal, Button} from 'react-bootstrap'
import React from 'react'
import {t} from '../../helpers/translate'

class ModalComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  close() {
    this.props.onClose(this.props.resetDataOnClose);
  }

  handleOptionalButton() {
    this.props.onSubmit();
  }

  render() {
    const { messageType, buttonName, closeButton, size, show, title, body } = this.props;
    const modalMessageType = messageType ? messageType : 'info';

    return <Modal bsSize={size} show={show} onHide={this.close.bind(this)}>
      <Modal.Header closeButton>
        <Modal.Title className={`${modalMessageType}-title`}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${modalMessageType}-body`}>
        <div>{body}</div>
      </Modal.Body>
      <Modal.Footer>
          <Button className="button-primary" onClick={this.close.bind(this)}>{closeButton ? closeButton : t('Close')}</Button>
          {buttonName && <Button className="button-secondary" onClick={this.handleOptionalButton.bind(this)}>{buttonName}</Button>}
      </Modal.Footer>
    </Modal>;
  }
}

ModalComponent.displayName = 'ModalComponent';
export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/common/ModalComponent.js